import { AxiosInstance } from "axios"

export interface UpdateAgencyUserRoleApiResponse {
  time: string
  apiStatus: string
  data: {
    userId: number
    previousRole: string
    taPriceConfigId: number
    message: string
    role: string
  }
  errorMessage?: string
  message?: string
}

export interface UpdateAgencyUserRoleApiRequest {
  role: string
}

export function updateAgencyUserRoleApi(
  userId: number,
  params: UpdateAgencyUserRoleApiRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: `/agent/agency/user/${userId}/role`,
    params,
  }) as Promise<{ data: UpdateAgencyUserRoleApiResponse }>
}
